import { toast } from 'react-hot-toast';
import React, { useEffect } from 'react';
import { RadioGroup, FormControl } from '@mui/material';


import {
  IInitialState,
  AccionDetalle,
  TipoAccionDetalle,
} from '../../Shared/data/FormReducer';
import Divider from '../Divider';
import Stepper from '../shared/Forms/Stepper';
import ToastDisplay from '../../Utils/ToastDisplay';
import FControlLabel from '../shared/Forms/FControlLabel';
import FormVideos from '../ModalEvaluacion/EvaluacionComponents/FormVideos';

interface IForm1 {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
}

const Form05: React.FC<IForm1> = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleNext = () => {
    let error1 = false;
    let error2 = false;
    let error3 = false;
    let error4 = false;

    if (props.state.vecesPorSemana === 0) {
      error1 = true;
    }
    if (props.state.dondeEntrenas === 0) {
      error2 = true;
    }
    if (
      props.state.diasPrioridad === 0 && // si no ha seleccionado un día de prioridad
      props.state.sexo === false && // si es mujer
      props.state.vecesPorSemana !== 5 // si es que la opción es distinta 5 veces por semana
    ) {
      error4 = true;
    }
    if (
      props.state.sexo === false &&
      props.state.vecesPorSemana === 4 &&
      props.state.diasPrioridad === 0
    ) {
      error3 = false;
    }

    if (!error1 && !error2 && !error4) {
      window.scrollTo(0, 0);
      props.dispatch({
        type: TipoAccionDetalle.CHANGE_NFORM,
        payload: props.state.nForm + 1,
      });
    }

    if (error3) {
      toast.error(
        <ToastDisplay
          title={`Hubo un error`}
          message={'Selecciona la prioridad de dias.'}
        />,
      );
      error3 = true;
    }
    if (error4) {
      toast.error(
        <ToastDisplay
          title={`Hubo un error`}
          message={'Selecciona la prioridad de dias.'}
        />,
      );
      error3 = true;
    }

    if (error1 || error2) {
      if (error1 && error2) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Completa todos los campos por favor.'}
          />,
        );
      }
      if (!error1 && error2) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Selecciones en donde entrena'}
          />,
        );
      }
      if (error1 && !error2) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Seleccione la cantidad de dias que entrena'}
          />,
        );
      }
      if (error4) {
        toast.error(
          <ToastDisplay
            title={`Hubo un error`}
            message={'Seleccione la cantidad de días por favor'}
          />,
        );
      }

      error1 = false;
      error2 = false;
      error4 = false;
    }
  };
  return (
    <div
      className="mb-3 container flex flex-column justify-content-center"
      style={{ margin: 'auto', paddingBottom: '65px' }}
    >

      <FormVideos 
        url='https://player.vimeo.com/external/1047862751.m3u8?s=32e89d7f2a380e8029ac2b54e0ca998b74308eba&logging=false'
      />

      <div className="container form-macro mb-4">

        <div>
          <div style={{ textAlign: 'left' }}>
            <h3 style={{ fontWeight: '700' }}>¿Cuántos días entrenarás por semana ?</h3>
          </div>
          <Divider type="title" />
          <div className="row">
            <div className="col-12" style={{ textAlign: 'left' }}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  value={props.state.vecesPorSemana}
                  onChange={(e) => {
                    props.dispatch({
                      type: TipoAccionDetalle.CHANGE_VECESPORSEMANA,
                      payload: e.target.value,
                    });
                  }}
                >
                  <FControlLabel value="3" label="3 veces por semana." fontWeight={500} />
                  <Divider type="option" />
                  <FControlLabel value="4" label="4 veces por semana." fontWeight={500} />
                  <Divider type="option" />
                  <FControlLabel value="5" label="5 veces por semana." fontWeight={500} />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
        <Divider type="option" />
        {props.state.sexo === false && props.state.vecesPorSemana === 4 && (
          <div>
            <Divider type="option" />
            <div style={{ textAlign: 'left' }}>
              <h3 style={{ fontWeight: '700' }}>
                ¿Cuantos días deseas priorizar tren inferior?
              </h3>
              <Divider type="option" />
            </div>
            <div className="row">
              <div className="col-12" style={{ textAlign: 'left' }}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={props.state.diasPrioridad}
                    onChange={(e) => {
                      props.dispatch({
                        type: TipoAccionDetalle.CHANGE_DIASPRIORIDAD,
                        payload: e.target.value,
                      });
                    }}
                  >
                    <FControlLabel
                      value="2"
                      label="2 veces por semana."
                      fontWeight={500}
                    />
                    <Divider type="option" />
                    <FControlLabel
                      value="3"
                      label="3 veces por semana."
                      fontWeight={500}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          </div>
        )}
        <Divider type="title" />

        <Divider type="option" />
        {props.state.sexo === false && props.state.vecesPorSemana === 3 && (
          <div>
            <Divider type="option" />
            <div style={{ textAlign: 'left' }}>
              <h3 style={{ fontWeight: '700' }}>¿Qué músculos vas a priorizar?</h3>
              <Divider type="option" />
            </div>
            <div className="row">
              <div className="col-12" style={{ textAlign: 'left' }}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={props.state.diasPrioridad}
                    onChange={(e) => {
                      props.dispatch({
                        type: TipoAccionDetalle.CHANGE_DIASPRIORIDAD,
                        payload: e.target.value,
                      });
                    }}
                  >
                    <FControlLabel
                      value="2"
                      label="2 veces pierna y 1 vez torso."
                      fontWeight={500}
                    />
                    <Divider type="option" />
                    <FControlLabel value="3" label="3 veces pierna" fontWeight={500} />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          </div>
        )}
        <Divider type="title" />

        <div>
          <div style={{ textAlign: 'left' }}>
            <h3 style={{ fontWeight: '700' }}>¿Cuánto tiempo entrenas al día?</h3>
            <Divider type="option" />
          </div>
          <div className="row">
            <div className="col-12" style={{ textAlign: 'left' }}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  value={props.state.tiempoRutinaDiaria}
                  onChange={(e) => {
                    props.dispatch({
                      type: TipoAccionDetalle.CHANGE_TIEMPORUTINADIARIA,
                      payload: e.target.value,
                    });
                  }}
                >
                  <FControlLabel value={'C'} label="30 a 40 min" fontWeight={500} />
                  <Divider type="option" />
                  <FControlLabel value={'M'} label="40 a 60 min" fontWeight={500} />
                  <Divider type="option" />
                  <FControlLabel value={'L'} label="60 min a más" fontWeight={500} />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
        <Divider type="title" />

        <div>
          <div style={{ textAlign: 'left' }}>
            <h3 style={{ fontWeight: '700' }}>¿Dónde entrenas?</h3>
            <Divider type="option" />
          </div>
          <div className="row">
            <div className="col-12" style={{ textAlign: 'left' }}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="1"
                  name="radio-buttons-group"
                  value={props.state.dondeEntrenas}
                  onChange={(e) => {
                    props.dispatch({
                      type: TipoAccionDetalle.CHANGE_DONDEENTRENAS,
                      payload: e.target.value,
                    });
                  }}
                >
                  <FControlLabel
                    value="23"
                    label="En casa: Tengo mancuernas, barra y discos de distintos pesos."
                    fontWeight={500}
                  />
                  <Divider type="option" />

                  <FControlLabel
                    value="22"
                    label="En casa: Tengo mancuernas, barra, banco y discos de distintos pesos."
                    fontWeight={500}
                  />
                  <Divider type="option" />

                  <FControlLabel value="10" label="En Gimnasio." fontWeight={500} />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <Stepper
        state={props.state}
        dispatch={props.dispatch}
        handleNext={handleNext}
        mostrarAdvertencia={false}
      />
    </div>
  );
};

export default Form05;
